/**
 * Minimal shape of the Google Identity Services API (`accounts.google.com/gsi/client`)
 * that Login/Register use for "Sign in with Google". Narrow on purpose — only the
 * two calls we make are typed. ESTIMATE: shape follows Google's published Identity
 * Services docs; VERIFY against https://accounts.google.com/gsi/client if Google
 * changes the callback payload.
 */
export interface GoogleCredentialResponse {
  credential: string;
}

export interface GoogleAccountsId {
  initialize: (config: {
    client_id: string;
    callback: (response: GoogleCredentialResponse) => void;
  }) => void;
  prompt: () => void;
}

export interface GoogleIdentityServices {
  accounts: { id: GoogleAccountsId };
}

export type WindowWithGoogle = Window & typeof globalThis & { google?: GoogleIdentityServices };

/** Reads `window.google` (Identity Services) without an `any` cast. */
export function getGoogleIdentity(): GoogleIdentityServices | undefined {
  return (window as WindowWithGoogle).google;
}
